import { render, staticRenderFns } from "./SendTokenValidateInfoCupo.vue?vue&type=template&id=22e8df16&"
import script from "./SendTokenValidateInfoCupo.vue?vue&type=script&lang=js&"
export * from "./SendTokenValidateInfoCupo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports